import UnderConstruction from './UnderConstruction.vue';

export default UnderConstruction;
